export enum EWeekDay {
	monday,
	tuesday,
	wednesday,
	thursday,
	friday,
	saturday,
	sunday
}